// extracted by mini-css-extract-plugin
export default {"margin":"mztqz1","center":"b9EMWX"};